import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsergaurdService } from './services/usergaurd/usergaurd.service';



const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./dashboard-container/dashboard-container.component').then(m => m.DashboardContainerComponent),
    canActivate: [UsergaurdService],
  },
  {
    path: 'ada',
    loadComponent: () => import('./pages/ada/ada.component').then(m => m.AdaComponent),
    canActivate: [UsergaurdService],
  },
  {
    path: 'ada-regional',
    loadComponent: () => import('./pages/ada/ada.component').then(m => m.AdaComponent),
    canActivate: [UsergaurdService],
  },
  {
    path: 'quick-pay',
    loadComponent: () => import('./pages/quick-pay/quick-pay.component').then(m => m.QuickPayComponent),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
